import Button from '@components/atoms/button';
import { BodyRegular, BodyRegularBold } from '@components/atoms/typography';

type TransferCommitBarProps = {
  stagedCount: number;
  readyCount: number;
  projectedBank: number;
  canCommit: boolean;
  isCommitting: boolean;
  onCommit: () => void;
  onReset: () => void;
};

const formatBank = (bank: number) => `£${bank.toFixed(1)}m`;

export const TransferCommitBar = ({
  stagedCount,
  readyCount,
  projectedBank,
  canCommit,
  isCommitting,
  onCommit,
  onReset
}: TransferCommitBarProps) => (
  <div
    className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 bg-primary-50 border border-primary-200 rounded-lg"
    data-cy="transfer-commit-bar"
  >
    <div className="flex flex-col">
      <BodyRegularBold>
        {readyCount} of {stagedCount} transfer{stagedCount === 1 ? '' : 's'}{' '}
        ready
      </BodyRegularBold>
      <BodyRegular textColor="text-neutral-600">
        Projected bank: {formatBank(projectedBank)}
      </BodyRegular>
    </div>
    <div className="flex gap-2">
      <Button
        variant="secondary"
        onClick={onReset}
        disabled={isCommitting}
        data-cy="transfer-commit-reset"
      >
        Reset
      </Button>
      <Button
        variant="primary"
        onClick={onCommit}
        disabled={!canCommit || isCommitting}
        data-cy="commit-transfers"
      >
        {isCommitting ? 'Making transfers...' : 'Make transfers'}
      </Button>
    </div>
  </div>
);
